
    export enum EnumUsedIn1Status {
			Allowed = 0,
			Approved = 1,
			NotAllowed = 2,
			Pending = 3,
			Terminated = 4,
			DiscontinuedForNewOrders = 5
    }